import { categoryPlans } from './fakeResponse';

export const getCategoryPlan = async () => {
  return categoryPlans;
};
